import { X, Keyboard } from 'lucide-react';

interface ShortcutHelpModalProps {
  isAdmin: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const baseShortcuts = [
  { keys: 'Ctrl/Cmd + B', description: 'Comprimi o espandi la sidebar' },
  { keys: 'Ctrl/Cmd + K', description: 'Apri il pannello comandi rapidi' },
  { keys: '?', description: 'Mostra questo elenco scorciatoie' },
  { keys: 'G H', description: 'Vai alla Home' },
  { keys: 'G B', description: 'Vai a Business' },
  { keys: 'G D', description: 'Vai a Dipendenze' },
];

const adminShortcuts = [
  { keys: 'G O', description: 'Vai a Documenti' },
];

export default function ShortcutHelpModal({ isAdmin, isOpen, onClose }: ShortcutHelpModalProps) {
  if (!isOpen) return null;

  const shortcuts = isAdmin ? [...baseShortcuts, ...adminShortcuts] : baseShortcuts;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

      <div className="relative w-full max-w-xl overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-2xl dark:border-zinc-800 dark:bg-zinc-900">
        <div className="flex items-center justify-between border-b border-zinc-200 px-5 py-4 dark:border-zinc-800">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">
              <Keyboard className="h-5 w-5" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900 dark:text-white">Comandi rapidi</h2>
              <p className="text-sm text-zinc-500 dark:text-zinc-400">Navigazione e produttività da tastiera</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-2 text-zinc-500 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-zinc-800 dark:hover:text-zinc-200"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-3 p-5">
          {shortcuts.map((shortcut) => (
            <div
              key={shortcut.keys}
              className="flex flex-col gap-2 rounded-xl border border-zinc-200 px-4 py-3 dark:border-zinc-800 sm:flex-row sm:items-center sm:justify-between"
            >
              <span className="text-sm font-medium text-zinc-800 dark:text-zinc-100">{shortcut.description}</span>
              <span className="inline-flex w-fit items-center rounded-lg bg-zinc-100 px-2.5 py-1 text-xs font-semibold uppercase tracking-wide text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200">
                {shortcut.keys}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
